import { validateVoucher } from '../util/voucherHelper';
import { sortBy } from 'lodash';
import { getDayFlag, getCurrentDayFlag } from '../util/timeHelper';
import { detectSpecial } from './detectSpecial';
import {
  getItemPriceForSpecialDiscount,
  getSpecialDetectionCount,
  detectMergeRequired,
  // getItemPricesObj,
} from './utilities';

export const _setSpecialFrames = (voucher, specialFrames) => {
  let x = {
    _id: voucher._id,
    name: voucher.voucherCode,
    type: voucher.type,
    isAvailablePickup: voucher.isAvailablePickup,
    isAvailableDelivery: voucher.isAvailableDelivery,
    isComplete: false,
    slots: [],
  };
  voucher.selectedCategories?.forEach((sp) => {
    new Array(Number(sp.quantity)).fill().forEach((_m, i) => {
      let u = {
        categoryKeys: sp.categories.filter((s) => s.isActive).map((s) => s._id),
        sizeKeys:
          sp.menuSizes?.filter((s) => s.isActive).map((s) => s._id) || [],
        modifierKeys:
          sp.subModifiers?.filter((s) => s.isActive).map((s) => s._id) || [],
        menuItems: sp.menuItems.filter((s) => !s.isActive).map((s) => s._id),
        id: i + 1,
        isSlotOccupied: false,
      };
      x.slots.push(u);
    });
  });
  x.slotLength = x.slots.length;
  specialFrames.push(x);
};

export const getVoucherDiscount = (
  currentOrder,
  payableAmount,
  rowItems,
  specialDiscount,
  allSpecials,
  orderSetup,
  publicHolidays,
  storeConfig
) => {
  let matchingVouchers = [];
  if (currentOrder?.voucherId && currentOrder?.menuItems?.length) {
    let myVouchers = currentOrder.selectedVoucher
      ? [currentOrder.selectedVoucher]
      : [];

    matchingVouchers = myVouchers.filter((v) => {
      return v._id === currentOrder.voucherId;
    });

    if (matchingVouchers?.length) {
      let selectedVoucher = matchingVouchers[0];
      if (
        validateVoucher(
          selectedVoucher,
          currentOrder,
          payableAmount,
          storeConfig
        ).success
      ) {
        let voucherDiscountObj = getVoucherDiscountedAmount(
          selectedVoucher,
          currentOrder,
          rowItems,
          specialDiscount,
          allSpecials,
          orderSetup,
          publicHolidays,
          storeConfig
        );
        if (voucherDiscountObj.isVoucherValid) {
          return {
            voucherFound: true,
            voucherDiscountObj: voucherDiscountObj,
            selectedVoucher: selectedVoucher,
          };
        } else {
          return {
            voucherFound: false,
          };
        }
      } else {
        return {
          voucherFound: false,
        };
      }
    } else {
      return {
        voucherFound: false,
      };
    }
  } else {
    return {
      voucherFound: false,
    };
  }
};

export function getVoucherDiscountedAmount(
  selectedVoucher,
  currentOrder,
  rowItems,
  specialDiscount,
  allSpecials,
  orderSetup,
  publicHolidays,
  storeConfig = {}
) {
  console.log('order egnine vouhcer zzzz');
  let resObj = {
    discount: 0,
    isVoucherValid: false,
    isItemOccupiedWithSpecials: false,
  };
  if (
    currentOrder &&
    (selectedVoucher?.type === '2' || selectedVoucher?.type === '1')
  ) {
    resObj.isVoucherValid = true;
    if (selectedVoucher.voucherType === '1') {
      resObj.discount = (
        (Number(currentOrder.payableAmount) *
          Number(selectedVoucher.discount)) /
        100
      ).toFixed(2);
      return resObj;
    } else {
      resObj.discount = selectedVoucher.discount;
      return resObj;
    }
  } else if (currentOrder && selectedVoucher?.type === '3') {
    let discountWithoutFlag = detectPersonalizedSpecial(
      currentOrder,
      selectedVoucher,
      rowItems,
      false,
      storeConfig,
      orderSetup?.isSpecialsManuallyDisabled,
      orderSetup?.autoDetectSpecialsWeb
    );
    if (!selectedVoucher.isAvailableWithSpecials) {
      let discountFlag = detectPersonalizedSpecial(
        currentOrder,
        selectedVoucher,
        rowItems,
        true,
        storeConfig,
        orderSetup?.isSpecialsManuallyDisabled,
        orderSetup?.autoDetectSpecialsWeb
      );
      if (
        discountWithoutFlag.voucherDiscount !== 0 &&
        discountFlag.voucherDiscount === 0
      ) {
        rowItems = sortBy(
          rowItems.filter(
            (f) => !discountWithoutFlag.usedIndexes.includes(f.primaryKey)
          ),
          'price'
        ).reverse();
        let specialObj = detectSpecial(
          currentOrder,
          rowItems,
          allSpecials,
          orderSetup,
          publicHolidays,
          storeConfig
        );

        let specials = specialObj.specials;
        //Calculate special's discount
        let discount = 0;
        specials.forEach((s) => {
          discount = discount + Number(s.discount);
        });
        if (
          Number(specialDiscount) - discount >
          discountWithoutFlag.voucherDiscount
        ) {
          resObj.isItemOccupiedWithSpecials = false;
          resObj.isVoucherValid = false;
          resObj.discount = discountFlag.voucherDiscount;
        } else {
          resObj.isItemOccupiedWithSpecials = true;
          resObj.isVoucherValid = true;
          resObj.specials = specials;
          resObj.discount = discountWithoutFlag.voucherDiscount;
        }
      } else {
        resObj.discount = discountFlag.voucherDiscount;
        resObj.isVoucherValid = true;
      }
    } else {
      resObj.isVoucherValid = true;
      resObj.discount = discountWithoutFlag.voucherDiscount;
    }
    console.log('resObj', resObj);
    return resObj;
  } else return resObj;
}

// Old production type-3 vouchers were saved with `voucherType: '1'` as a
// default even though they are fixed-price vouchers, so voucherType alone
// cannot be trusted. The decisive factor is which field carries a value:
// - `discountedPrice` set  => fixed-price voucher (legacy flow)
// - otherwise `discount` set => percentage voucher
export const isPercentagePersonalizedVoucher = (voucher) => {
  if (voucher?.voucherType !== '1') return false;
  const discountedPrice = Number(voucher.discountedPrice);
  const hasDiscountedPrice =
    voucher.discountedPrice !== '' &&
    voucher.discountedPrice !== null &&
    voucher.discountedPrice !== undefined &&
    !isNaN(discountedPrice);
  if (hasDiscountedPrice) return false;
  return Number(voucher.discount) > 0;
};

// For type '3' (personalized) vouchers, returns the price the eligible
// item's single unit should be discounted to.
// - percentage voucher: `discount` holds the percentage, so the unit price
//   is reduced by that percentage of the item's own price.
// - otherwise: fixed-price voucher, unit is repriced to `discountedPrice`.
export const getVoucherDiscountedUnitPrice = (voucher, oneItemPrice) => {
  if (isPercentagePersonalizedVoucher(voucher)) {
    const percentage = Number(voucher.discount) || 0;
    return oneItemPrice - (oneItemPrice * percentage) / 100;
  }
  return Number(voucher.discountedPrice);
};

// For percentage (voucherType '1') type-3 vouchers with
// `applyPercentageDiscountToAll` enabled: instead of discounting a single
// unit via the quantity slots, every unit in the cart that matches the
// voucher's criteria gets the percentage discount. Half-half units are not
// eligible. `rowItems` is already expanded to one entry per unit, so
// quantities are covered implicitly (3 orange drinks = 3 discounted units).
export const getApplyToAllPercentageDiscount = (voucher, rowItems) => {
  const voucherDiscountObj = { voucherDiscount: 0, usedIndexes: [] };
  const percentage = Number(voucher.discount) || 0;
  const { menuItems, categories, menuSizes, subModifiers } =
    voucher?.selectedCategories?.[0] || {};

  rowItems.forEach((rI) => {
    // half-half / four-quarter units are excluded from apply-to-all
    if (rI.isHalf || rI.isQuarter) return;

    const menuItemMatched = menuItems?.length
      ? menuItems.some((vItem) => vItem?.isActive && vItem?._id === rI._id)
      : categories?.some(
          (vCat) => vCat?.isActive && vCat?._id === rI.categoryId
        );
    const sizeMatched =
      menuSizes?.some(
        (vSize) => vSize?.isActive && vSize?._id === rI.sizeKey
      ) ||
      subModifiers?.some(
        (vMod) => vMod?.isActive && vMod?._id === rI.sizeKey
      );

    if (menuItemMatched && sizeMatched) {
      voucherDiscountObj.voucherDiscount +=
        (Number(rI.price) * percentage) / 100;
      voucherDiscountObj.usedIndexes.push(rI.primaryKey);
    }
  });

  return voucherDiscountObj;
};

export function detectPersonalizedSpecial(
  currentOrder,
  voucher,
  rowItems,
  filterOutUsedItems,
  storeConfig = {},
  isSpecialsManuallyDisabled = false,
  autoDetectSpecialsWeb
) {
  window.itemsUsed = [];
  const specialItemsObj = [];
  let specialFrames = getPersonalizedSpecialFrames(
    currentOrder,
    voucher,
    storeConfig
  );
  if (filterOutUsedItems) {
    rowItems = rowItems.filter((s) => !s.itemsUsedInSpecials);
  }
  let voucherDiscountObj = { voucherDiscount: 0, usedIndexes: [] };

  // Percentage voucher configured to discount every matching cart item:
  // skip slot detection entirely (slots cap the discount at the configured
  // quantity). specialFrames still gates day / order-type availability.
  if (
    isPercentagePersonalizedVoucher(voucher) &&
    voucher?.applyPercentageDiscountToAll
  ) {
    if (rowItems?.length && specialFrames?.length) {
      return getApplyToAllPercentageDiscount(voucher, rowItems);
    }
    return voucherDiscountObj;
  }

  if (rowItems?.length && specialFrames?.length) {
    getSpecialDetectionCount(
      specialFrames[0],
      rowItems,
      0,
      specialItemsObj,
      isSpecialsManuallyDisabled,
      autoDetectSpecialsWeb
    );

    if (specialItemsObj?.length) {
      let finalSpecial = specialItemsObj[0];
      let itemsToBeAddedInSpecials = [];
      finalSpecial.slots.forEach((ss) => {
        let rowMenuItems = JSON.parse(JSON.stringify(currentOrder.menuItems));
        let filteredItems = [];
        if (ss.isHalf) {
          filteredItems = rowMenuItems.filter(
            (ff) =>
              ff._id === ss.itemId &&
              ff.isSecondHalf === false &&
              ff.orderIndex === ss.orderIndex
          );
        } else {
          filteredItems = rowMenuItems.filter(
            (ff) => ff._id === ss.itemId && ff.orderIndex === ss.orderIndex
          );
        }
        if (filteredItems?.length) {
          filteredItems.forEach((ftmm) => {
            let ttml = { ...ftmm };
            if (detectMergeRequired(ss, ttml)) {
              ttml.selectedSizes = ttml.selectedSizes.filter(
                (ggm) => ss.sizeKeyMatched === ggm._id
              );
              if (ttml.selectedSizes?.length) {
                ttml.selectedSizes[0].quantity = ttml.isHalf ? 0.5 : 1;
                if (ttml.isHalf) {
                  let othersHalf = rowMenuItems.find(
                    (m) =>
                      m.halfIndex === ttml.halfIndex && m.isSecondHalf === true
                  );
                  if (othersHalf) {
                    ttml.urlHalf = othersHalf.urlS3;
                    ttml._idHalf = othersHalf._id;
                    ttml.nameHalf = othersHalf.name;
                    ttml.selectedSizesHalf = [...othersHalf.selectedSizes];
                    ttml.selectedIngredientsHalf = [
                      ...othersHalf.selectedIngredients,
                    ];
                    ttml.removedIngredientsHalf = [
                      ...othersHalf.removedIngredients,
                    ];
                    ttml.selectedExtraIngredientsHalf = [
                      ...othersHalf.selectedExtraIngredients,
                    ];
                    ttml.selectedSizesHalf = othersHalf.selectedSizes.filter(
                      (ggm) =>
                        ss.sizeKeys?.includes(ggm._id) ||
                        ss.modifierKeys?.includes(ggm._id)
                    );
                    ttml.selectedSizesHalf[0].quantity = 0.5;
                  }
                }
                itemsToBeAddedInSpecials.push(ttml);
              }
            }
          });
        }
        voucherDiscountObj.usedIndexes.push(ss.primaryKey);
      });
      if (itemsToBeAddedInSpecials?.length) {
        let totalCost = 0;
        let discountedItemsPrice = 0;
        itemsToBeAddedInSpecials.forEach((m) => {
          // can try: getItemPrice
          const itemPrice = Number(getItemPriceForSpecialDiscount(m));
          totalCost += itemPrice;
          if (discountedItemsPrice > 0) {
            discountedItemsPrice += itemPrice;
          } else {
            const oneItemPrice = itemPrice / (m?.quantity || 1);
            discountedItemsPrice +=
              itemPrice -
              oneItemPrice +
              getVoucherDiscountedUnitPrice(voucher, oneItemPrice);
          }
        });

        voucherDiscountObj.voucherDiscount = totalCost - discountedItemsPrice;
      }
    }

    if (voucherDiscountObj.voucherDiscount <= 0) {
      let totalCost = 0;
      let discountedItemsPrice = 0;
      const { menuItems, menuSizes, subModifiers } =
        voucher?.selectedCategories[0];
      currentOrder?.menuItems?.forEach((mI) => {
        const { _id, selectedSizes, quantity } = mI;

        const vMenuSize = menuSizes?.some(
          (vMenuSize) =>
            vMenuSize?.isActive && vMenuSize?._id === selectedSizes[0]?._id
        );
        const vSubModifier = subModifiers?.some(
          (vSubModifier) =>
            vSubModifier?.isActive &&
            vSubModifier?._id === selectedSizes[0]?._id
        );

        const isMenuItemEligibleForVoucher =
          menuItems?.some(
            (vMenuItem) => vMenuItem?.isActive && vMenuItem?._id === _id
          ) &&
          (vMenuSize || vSubModifier) &&
          rowItems.some((rI) => rI?._id === _id);

        if (isMenuItemEligibleForVoucher) {
          const itemPrice = Number(getItemPriceForSpecialDiscount(mI));
          totalCost += itemPrice;
          if (discountedItemsPrice > 0) {
            discountedItemsPrice += itemPrice;
          } else {
            const oneItemPrice = itemPrice / quantity;
            discountedItemsPrice +=
              itemPrice -
              oneItemPrice +
              getVoucherDiscountedUnitPrice(voucher, oneItemPrice);
          }
        }
      });

      voucherDiscountObj.voucherDiscount = totalCost - discountedItemsPrice;
    }
  }
  return voucherDiscountObj;
}

export function getPersonalizedSpecialFrames(
  currentOrder,
  voucher,
  storeConfig
) {
  let specialFrames = [];
  if (
    (currentOrder.orderType === '1' && voucher.isAvailablePickup) ||
    (currentOrder.orderType === '2' && voucher.isAvailableDelivery) ||
    (currentOrder.orderType === '3' && voucher.isAvailableDineIn) ||
    currentOrder.orderType === '0'
  ) {
    if (currentOrder.deliveryDate) {
      if (
        voucher.hasOwnProperty(
          getDayFlag(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
        ) &&
        voucher[
          getDayFlag(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
        ] === true
      ) {
        _setSpecialFrames(voucher, specialFrames);
      }
    } else {
      if (
        voucher.hasOwnProperty(
          getCurrentDayFlag(storeConfig.timeZone)?.dayText
        ) &&
        voucher[getCurrentDayFlag(storeConfig.timeZone)?.dayText] === true
      ) {
        _setSpecialFrames(voucher, specialFrames);
      }
    }
  }
  return specialFrames;
}
